<template>
    <div class="text-center">
        <v-dialog
            v-model="dialog"
            class="dialog-container"
            width="75vw"
            height="75vh"
            @click:outside="closeDialog"
        >
            <v-card>
                <v-card-title class="text-h5 blue lighten-5">
                    {{ title }} Details
                </v-card-title>

                <array-view
                    :headers="headers"
                    :items="[activeItem]"
                    :page="1"
                    :size="1"
                    class="elevation-1"
                    hide-default-footer
                    :is-fetching="false"
                    :show-icons="false"
                />

                <v-spacer />
                <div class="details-container">
                    <v-card-title>
                        <div class="text-h6">{{ textTitle }}</div>
                    </v-card-title>
                    <v-card-text>
                        {{ text }}
                    </v-card-text>
                </div>
                <v-divider />
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import ArrayView from '@/components/ArrayView.vue'

    export default {
        components: { ArrayView },
        props: {
            title: {
                type: String,
                required: true
            },
            activeItem: {
                type: Object,
                required: true
            },
            isSms: {
                type: Boolean,
                required: true
            },
            headers: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                dialog: true
            }
        },
        computed: {
            textTitle() {
                return `${this.isSms ? 'SMS' : 'Viber'} Text`
            },
            text() {
                return this.isSms ? this.activeItem.smsText : this.activeItem.viberText
            }
        },
        methods: {
            closeDialog() {
                this.$emit('close-dialog')
            }
        }
    }
</script>
<style scoped>
.details-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
</style>
